import { Chart } from './Chart.js';
import { jsx } from 'react/jsx-runtime';

function HorizontalBarChart({
  annotationsLookupTable = {},
  data,
  dimensions,
  renderLegendContent,
  renderTooltipContent,
  showLegend,
  type = 'default',
  xAxisOptions,
  yAxisOptions
}) {
  return /*#__PURE__*/jsx(Chart, {
    dimensions: dimensions,
    annotationsLookupTable: annotationsLookupTable,
    data: data,
    renderTooltipContent: renderTooltipContent,
    showLegend: showLegend,
    type: type,
    xAxisOptions: xAxisOptions,
    yAxisOptions: yAxisOptions,
    renderLegendContent: renderLegendContent
  });
}

export { HorizontalBarChart };
